"use strict";
// Copyright 2015 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.protos = exports.v3 = exports.v3beta1 = exports.v2 = exports.TranslationServiceClient = void 0;
const v2 = require("./v2");
exports.v2 = v2;
/**
 * The `@google-cloud/translate` package has the following named exports:
 *
 * - `{@link TranslationServiceClient}` class - constructor for v3 of the Translation API.
 * See {@link v3.TranslationServiceClient} for client methods.
 * - `v3` - client for the v3 backend service version. It exports:
 *    - `TranslationServiceClient` - Reference to {@link v3.TranslationServiceClient}
 * - `v3beta1` - client for the v3beta1 backend service version. It exports:
 *    - `TranslationServiceClient` - Reference to {@link v3beta1.TranslationServiceClient}
 * - `v2` - client for the v2 backend service version. It exports:
 *    - `Translate` - Reference to {@link v2.Translate}
 *
 * @module {constructor} @google-cloud/translate
 * @alias nodejs-translate
 *
 * @example <caption>Install the v3 client library with <a
 * href="https://www.npmjs.com/">npm</a>:</caption>
 * npm install --save @google-cloud/translate
 *
 * @example <caption>Import the v3 client library:</caption>
 * const {TranslationServiceClient} = require('@google-cloud/translate');
 *
 * @example <caption>Create a v3 client that uses <a
 * href="https://goo.gl/64dyYX">Application Default Credentials
 * (ADC)</a>:</caption>
 * const client = new TranslationServiceClient();
 *
 * @example <caption>include:samples/quickstart.js</caption>
 * region_tag:translate_quickstart
 * Full quickstart example:
 *
 * @example <caption>Install the v3beta1 client library:</caption>
 * npm install --save @google-cloud/translate
 *
 * @example <caption>Import the v3beta1 client library:</caption>
 * const {TranslationServiceClient} =
 * require('@google-cloud/translate').v3beta1;
 */
const v3beta1 = require("./v3beta1");
exports.v3beta1 = v3beta1;
const v3 = require("./v3");
exports.v3 = v3;
__exportStar(require("./v3"), exports);
const TranslationServiceClient = v3.TranslationServiceClient;
exports.TranslationServiceClient = TranslationServiceClient;
// For compatibility with JavaScript libraries we need to provide this default export:
// tslint:disable-next-line no-default-export
exports.default = {
    v2,
    v3beta1,
    v3,
    TranslationServiceClient,
};
const protos = require("../protos/protos");
exports.protos = protos;
//# sourceMappingURL=index.js.map